import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const aiSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("ai-settings-nro-heading", "AI Settings"),
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      (featureOn("innovation_insiders_opt_in") ||
        featureOn("generative_ai_kill_switch") ||
        featureOn("aggregated_anonymous_ai_training_kill_switch") ||
        featureOn("all_data_ai_training_kill_switch")) &&
      hasPermission("company", {
        permission: "admin",
      })
    );
  },
  additionalSearchTerms: (t: I18nT<"dashboard-navigation">) => {
    return [
      {
        keywords: [t("ai-settings-nro-additional-keyword-innovation-insiders", "Innovation Insiders")],
      },
    ];
  },
  additionalSearchableFeatures: () => ({}),
};
